import { gql } from "@apollo/client";

// ── Queries ──────────────────────────────────────────────────────────

export const GET_LEADS_LIST = gql`
  query GetLeadsList(
    $filter: LeadFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    allLeads(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      status
      source
      triageStatus
      situation
      method
      bookingTypeId
      archivedAt
      createdAt
      customers {
        id
        name
        alias
        email
        isPrimary
      }
    }
    _allLeadsMeta(filter: $filter) {
      count
    }
  }
`;

export const GET_LEAD_DETAIL = gql`
  query GetLeadDetail($id: String!) {
    Lead(id: $id) {
      id
      status
      source
      triageStatus
      situation
      method
      bookingTypeId
      setupIntentId
      availabilitySlotId
      customUrlId
      archivedAt
      createdAt
      updatedAt
      questions {
        isTimeSensitive
        isInvolvingTheCourt
        isPaperworkAvailable
      }
      formData
      customers {
        id
        name
        alias
        email
        phoneNumber
        isPrimary
        businessName
        title
      }
    }
  }
`;

// The session a booked lead converted into (bookings.lead_id).
export const GET_LEAD_BOOKING = gql`
  query GetLeadBooking($filter: BookingFilter) {
    allBookings(filter: $filter, page: 0, perPage: 1) {
      id
      state
      bookingType {
        id
        name
      }
      availability {
        id
        date
        startTime
      }
    }
  }
`;

// The availability slot the lead selected in the funnel (not yet booked).
export const GET_LEAD_AVAILABILITY = gql`
  query GetLeadAvailability($id: String!) {
    Availability(id: $id) {
      id
      date
      startTime
      endTime
    }
  }
`;

// First-touch attribution (leads.custom_url_id).
export const GET_LEAD_CUSTOM_URL = gql`
  query GetLeadCustomUrl($id: String!) {
    CustomUrl(id: $id) {
      id
      slug
    }
  }
`;

// IDs of every lead matching a filter — used to resolve "select all N
// matching" across pages for bulk actions (leads have no export query).
export const GET_LEAD_IDS = gql`
  query GetLeadIds($filter: LeadFilter, $perPage: Int) {
    allLeads(filter: $filter, page: 0, perPage: $perPage) {
      id
    }
  }
`;

// ── Mutations ────────────────────────────────────────────────────────

export const ARCHIVE_LEADS = gql`
  mutation ArchiveLeads($ids: [String!]!, $archive: Boolean!) {
    archiveLeads(ids: $ids, archive: $archive) {
      id
      status
      archivedAt
    }
  }
`;

// Set the human working state (triage_status) on one or more leads. The
// response echoes id + triageStatus so Apollo's normalized cache updates the
// row(s) in place without a refetch.
export const SET_LEAD_TRIAGE = gql`
  mutation SetLeadTriage($ids: [String!]!, $triageStatus: String!) {
    setLeadTriage(ids: $ids, triageStatus: $triageStatus) {
      id
      triageStatus
    }
  }
`;
